import { render, staticRenderFns } from "./buttonform.vue?vue&type=template&id=c668fe06&"
import script from "./buttonform.vue?vue&type=script&lang=js&"
export * from "./buttonform.vue?vue&type=script&lang=js&"
import style0 from "./buttonform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports